import React from "react";

export function TimeColumnFormatter(cellContent) {

    let startDate = Date.parse(cellContent.createdAt)/1000;
    let lastDate = Date.parse(cellContent.lastUpdate)/1000;
    let range = (lastDate-startDate);
    function countdown(s) {
        const d = Math.floor(s / (3600 * 24));
        s  -= d * 3600 * 24;
        const h = Math.floor(s / 3600);
        s  -= h * 3600;
        const m = Math.floor(s / 60);
        s  -= m * 60;
        const tmp = [];
        (d) && tmp.push(d + " ימים ");
        (d || h) && tmp.push(h + " שעות ");
        (d || h || m) && tmp.push(m + " דקות ");
        return tmp.join(' ');
    }

    return (
        <>
            <div className="d-flex justify-content-start">
                <span className="text-dark-75 font-weight-bolder d-block fs-1 mr-1">
                    {cellContent.createdAt.slice(11, 16)}
                </span>
                <span className="text-dark-75 font-weight-bolder d-block fs-1">
                    {cellContent.createdAt.slice(8, 10)}-{cellContent.createdAt.slice(5, 7)}-{cellContent.createdAt.slice(0, 4)}
                </span>
            </div>
            <div className="text-dark-75 font-weight-bolder d-block text-nowrap">{countdown(range)}</div>
        </>
    );
}
